/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const createDirectToBuyConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc',
  rpcName: 'createDirectToBuyConfig',
  auth: 'external',
  fingerprint: 'cLjEeXhdr1wjs9bcoic28ZwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createDirectToBuyConfigWithIdRpc = {
  serviceName: 'com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc',
  rpcName: 'createDirectToBuyConfigWithId',
  auth: 'external',
  fingerprint: 'bKYrpQPOsqEjs9bcoic28ZwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDirectToBuyConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc',
  rpcName: 'getDirectToBuyConfig',
  auth: 'external',
  fingerprint: 'RwkVwEpJCiYiIbA7z4Udd5wP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};